import { textInputType } from './FormFieldTypes';

export const getLocationFormFields = (): textInputType[] => [
  {
    placeholder: 'Latitude',
    label: 'Latitude',
    name: 'latitude',
    type: 'textInput',
    required: false,
    disabled: true,
  },
  {
    placeholder: 'Longitude',
    label: 'Longitude',
    name: 'longitude',
    type: 'textInput',
    required: false,
    disabled: true,
  },
  {
    placeholder: 'Timezone',
    label: 'Timezone',
    name: 'timezone',
    type: 'textInput',
    required: false,
    disabled: true,
  },
];
